import * as React from "react";
import { redirectToLogout } from "@platform/core";
import { AvatarNav, List, ListItem, ListItemButton, ListItemText, Paper } from "@platform/style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowLeft,
  faGear,
  faRightFromBracket,
  faArrowUpRightFromSquare,
} from "@fortawesome/sharp-regular-svg-icons";

library.add(faArrowLeft, faGear, faRightFromBracket);

interface LeftMenuWindowProps {
  handleClose: () => void;
  isAdmin: boolean;
  linkToOneAdmin: () => Promise<void>;
  setLinkToOneAdminError: React.Dispatch<React.SetStateAction<Error | undefined>>;
}

export default function UserMenuLeftBar(props: LeftMenuWindowProps) {
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndex(index);
    if (index === 0) {
      props.handleClose();
    } else if (index === 2) {
      redirectToLogout();
    } else if (index === 3) {
      props
        .linkToOneAdmin()
        .then(() => props.setLinkToOneAdminError(undefined))
        .catch((error) => props.setLinkToOneAdminError(error as Error));
    }
  };

  return (
    <Paper elevation={0} data-testid={"LeftPaneWindow"}>
      <List
        sx={{
          "&& .Mui-selected": {
            backgroundColor: "secondary.light",
            "&:focus": {
              backgroundColor: "secondary.dark",
              borderStyle: "solid",
              borderWidth: "1px",
              borderColor: "primary.main",
            },
            "&:hover": {
              backgroundColor: "secondary.light",
            },
            "& .MuiListItemText-primary": {
              fontWeight: "bold",
            },
          },
        }}
      >
        <ListItem disablePadding>
          <ListItemButton
            selected={selectedIndex === 0}
            onClick={(event) => handleListItemClick(event, 0)}
            sx={{
              zIndex: 1,
              "&:focus": {
                backgroundColor: "secondary.dark",
                borderStyle: "solid",
                borderWidth: "1px",
                borderColor: "primary.main",
              },
              "&:hover": {
                backgroundColor: "secondary.light",
                fontWeight: "bold",
              },
            }}
          >
            <AvatarNav>
              <FontAwesomeIcon icon={faArrowLeft} size="lg" />
            </AvatarNav>
            <ListItemText primary={"Back"} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={selectedIndex === 1}
            onClick={(event) => handleListItemClick(event, 1)}
            sx={{
              "&:focus": {
                backgroundColor: "secondary.dark",
                borderStyle: "solid",
                borderWidth: "1px",
                borderColor: "primary.main",
              },
              "&:hover": {
                backgroundColor: "secondary.light",
                fontWeight: "bold",
              },
            }}
          >
            <AvatarNav
              sx={{
                backgroundColor: "text.paper",
                color: "primary.main",
              }}
            >
              <FontAwesomeIcon icon={faGear} size="lg" />
            </AvatarNav>
            <ListItemText primary={"Account Settings"} />
          </ListItemButton>
        </ListItem>
        {props.isAdmin && (
          <ListItem disablePadding>
            <ListItemButton
              selected={selectedIndex === 3}
              onClick={(event) => handleListItemClick(event, 3)}
              sx={{
                "&:focus": {
                  backgroundColor: "secondary.dark",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  borderColor: "primary.main",
                },
                "&:hover": {
                  backgroundColor: "secondary.light",
                  fontWeight: "bold",
                },
              }}
            >
              <AvatarNav>
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="lg" />
              </AvatarNav>
              <ListItemText primary={"One Admin"} />
            </ListItemButton>
          </ListItem>
        )}
        <ListItem disablePadding>
          <ListItemButton
            selected={selectedIndex === 2}
            onClick={(event) => handleListItemClick(event, 2)}
            sx={{
              "&:focus": {
                backgroundColor: "secondary.dark",
                borderStyle: "solid",
                borderWidth: "1px",
                borderColor: "primary.main",
              },
              "&:hover": {
                backgroundColor: "secondary.light",
                fontWeight: "bold",
              },
            }}
          >
            <AvatarNav>
              <FontAwesomeIcon icon={faRightFromBracket} size="lg" />
            </AvatarNav>
            <ListItemText primary={"Log out"} />
          </ListItemButton>
        </ListItem>
      </List>
    </Paper>
  );
}
